/* eslint-disable no-undef */
import "./src/styles/global.css";
import { getStoredScrollPosition } from "./src/helpers/postOverviewFilterStorage";

// Restore the scroll position stored for a listing page (see postOverviewFilterStorage.ts) when
// navigating to it, so links like breadcrumbs return to the same position the browser's back
// button would. Gatsby's `shouldUpdateScroll` only gates whether it performs its own (default)
// scroll afterwards, so we scroll manually here and return `false` to suppress that default.
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  const savedScrollY = getStoredScrollPosition(location.pathname);
  if (savedScrollY !== null) {
    window.scrollTo(0, savedScrollY);
    return false;
  }
  return true;
};
